import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "odn_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminApi = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  // deals
  listDeals: () => axios.get(`${API}/admin/deals`, auth()),
  createDeal: (data) => axios.post(`${API}/admin/deals`, data, auth()),
  updateDeal: (id, data) => axios.put(`${API}/admin/deals/${id}`, data, auth()),
  deleteDeal: (id) => axios.delete(`${API}/admin/deals/${id}`, auth()),
  // projects
  listProjects: () => axios.get(`${API}/admin/projects`, auth()),
  createProject: (data) => axios.post(`${API}/admin/projects`, data, auth()),
  updateProject: (id, data) => axios.put(`${API}/admin/projects/${id}`, data, auth()),
  deleteProject: (id) => axios.delete(`${API}/admin/projects/${id}`, auth()),
  importAbuDhabi: () => axios.post(`${API}/admin/projects/import-abudhabi`, {}, auth()),
  // leads
  listLeads: () => axios.get(`${API}/admin/leads`, auth()),
  updateLead: (id, status) => axios.patch(`${API}/admin/leads/${id}`, { status }, auth()),
  deleteLead: (id) => axios.delete(`${API}/admin/leads/${id}`, auth()),
  // crm — units (supply)
  listUnits: () => axios.get(`${API}/admin/crm/units`, auth()),
  createUnit: (data) => axios.post(`${API}/admin/crm/units`, data, auth()),
  updateUnit: (id, data) => axios.patch(`${API}/admin/crm/units/${id}`, data, auth()),
  deleteUnit: (id) => axios.delete(`${API}/admin/crm/units/${id}`, auth()),
  // crm — inquiries (demand)
  listInquiries: () => axios.get(`${API}/admin/crm/inquiries`, auth()),
  createInquiry: (data) => axios.post(`${API}/admin/crm/inquiries`, data, auth()),
  updateInquiry: (id, data) => axios.patch(`${API}/admin/crm/inquiries/${id}`, data, auth()),
  deleteInquiry: (id) => axios.delete(`${API}/admin/crm/inquiries/${id}`, auth()),
  inquiryMatches: (id) => axios.get(`${API}/admin/crm/inquiries/${id}/matches`, auth()),
  // crm — matches inbox
  listMatches: () => axios.get(`${API}/admin/crm/matches`, auth()),
  matchesCount: () => axios.get(`${API}/admin/crm/matches/count`, auth()),
  updateMatch: (id, status) => axios.patch(`${API}/admin/crm/matches/${id}`, { status }, auth()),
  deleteMatch: (id) => axios.delete(`${API}/admin/crm/matches/${id}`, auth()),
  // crm — ai parse
  crmParse: (text, kind) => axios.post(`${API}/admin/crm/parse`, { text, kind }, auth()),
  // project import (scrape newest from source, staged for review)
  importScan: (limit = 80) => axios.post(`${API}/admin/projects/import/scan?limit=${limit}`, {}, auth()),
  importStatus: () => axios.get(`${API}/admin/projects/import/status`, auth()),
  importStaged: () => axios.get(`${API}/admin/projects/import/staged`, auth()),
  importDismiss: (id) => axios.delete(`${API}/admin/projects/import/staged/${id}`, auth()),
  importPublish: (ids) => axios.post(`${API}/admin/projects/import/publish`, { ids }, auth()),
  translateProjects: () => axios.post(`${API}/admin/projects/translate`, {}, auth()),
  translateStatus: () => axios.get(`${API}/admin/projects/translate/status`, auth()),
};

export const fetchPublicDeals = () => axios.get(`${API}/deals`);
export const fetchPublicProjects = () => axios.get(`${API}/projects`);
